<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" :btnConfigurazioniVisible="btnConfigurazioniVisible" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Lis:</label>
                        <b-form-input v-model="filtroConfigurazioneProfiliLis.codice" type="search" id="codice" placeholder="Codice Lis"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione Profilo Lis:</label>
                        <b-form-input v-model="filtroConfigurazioneProfiliLis.descrizione" type="search" id="descrizione" placeholder="Descrizione Profilo Lis"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-profili-lis-list-component ref="RsaConfigurazioneProfiliLisListComponent" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneProfiliLisListComponent from "../components/RsaConfigurazioneProfiliLisListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneProfiliLisListComponent },
    data() {
        return {
            filtroConfigurazioneProfiliLis: { codice: null, descrizione: null },
            btnNewVisible: true,
            btnBackVisible: true,
            btnConfigurazioniVisible: true,
            pathResource: "/rsaprofililis",
            linkConfigurazioni: "/configurazioni",
            linkedit: "/rsaconfigurazioneprofililis",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneProfiliLisListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.filtroConfigurazioneProfiliLis = {};
            sessionStorage["filtroConfigurazioneProfiliLis"] = JSON.stringify(me.filtroConfigurazioneProfiliLis);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneProfiliLis"] = JSON.stringify(me.filtroConfigurazioneProfiliLis);
            // console.log("onSubmit", me.filtroConfigurazioneProfiliLis);

            me.loadData();
        },
        onUpdateFilter(filterData) {
            this.filtroConfigurazioneProfiliLis = filterData;
            // console.log("onUpdateFilter", filterData);
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style></style>
